import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { AngularMaterialService, ErrorParseService, IPaymentCreditFormCC, IPaymentCreditFormExt } from '../../commons';
import { Store } from '@ngrx/store';
import * as fromPaymentCredit from './state/payment-credit.selectors';
import * as PaymentCreditAction from './state/payment-credit.actions';
import * as lgeApp from '../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';
import { slideInDownAnimation } from 'src/app/app.animation';

@Component({
    selector: 'payment-credit-screen',
    templateUrl: 'payment-credit.component.html',
    styleUrls: ['payment-credit.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCreditScreenComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;

    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;

    @Input() stateFormCCData$: Observable<IPaymentCreditFormCC | null>;
    stateFormCCDataSubscription: Subscription;
    @Input() stateProcessedFormCCData$: Observable<IPaymentCreditFormCC | null>;
    stateProcessedFormCCDataSubscription: Subscription;

    @Input() stateFormCGData$: Observable<IPaymentCreditFormExt | null>;
    stateFormCGDataSubscription: Subscription;
    @Input() stateProcessedFormCGData$: Observable<IPaymentCreditFormExt | null>;
    stateProcessedFormCGDataSubscription: Subscription;

    @Input() stateFormPPData$: Observable<IPaymentCreditFormExt | null>;
    stateFormPPDataSubscription: Subscription;
    @Input() stateProcessedFormPPData$: Observable<IPaymentCreditFormExt | null>;
    stateProcessedFormPPDataSubscription: Subscription;

    @Input() stateFormESData$: Observable<IPaymentCreditFormExt | null>;
    stateFormESDataSubscription: Subscription;
    @Input() stateProcessedFormESData$: Observable<IPaymentCreditFormExt | null>;
    stateProcessedFormESDataSubscription: Subscription;

    // @Input() stateFormCIData$: Observable<IPaymentCreditFormCI | null>;
    // stateFormCIDataSubscription: Subscription;
    // @Input() stateProcessedFormCIData$: Observable<IPaymentCreditFormCI | null>;
    // stateProcessedFormCIDataSubscription: Subscription;

    displayedColumnsFormccToPayAsCredit = ['requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection_501', 'effdt', 'statusDescr', 'processCreditCardPayment', 'view'];
    displayedColumnsFormCCPaidDetails = ['requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection_501', 'effdt', 'statusDescr', 'confirmationNo', 'view'];

    displayedColumnsFormExtCGPPToPayAsCredit = ['requestNo', 'projectName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'processCreditCardPayment', 'view'];
    displayedColumnsFormExtCGPPPaidDetails = ['requestNo', 'projectName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'confirmationNo', 'view'];

    displayedColumnsFormExtESToPayAsCredit = ['requestNo', 'eventName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'processCreditCardPayment', 'view'];
    displayedColumnsFormExtESPaidDetails = ['requestNo', 'eventName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'confirmationNo', 'view'];

    FormCCPaidDetails = [];
    FormccToPayAsCreditDetails = [];

    FormCGPaidDetails = [];
    FormCGToPayAsCreditDetails = [];

    FormPPPaidDetails = [];
    FormPPToPayAsCreditDetails = [];

    FormESPaidDetails = [];
    FormESToPayAsCreditDetails = [];

    // FormCIPaidDetails = [];
    // FormCIToPayAsCreditDetails = [];

    constructor(
        private store: Store<fromPaymentCredit.State>,
        private ref: ChangeDetectorRef,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
    ) {
        this.selectState();
        // this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditInitState());
    }


    ngOnInit() {
        this.startSubscriptions();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormCCState());
            this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormCGState());
            this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormPPState());
            this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormESState());
            // this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormCIState());
        });
    }

    getStatusClass(status) {
        const possibleStatus = ['Paid Credit', 'Approved'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromPaymentCredit.getPaymentCreditScreenPending).pipe(skipWhile(data => data === undefined || data === null));
        this.error$ = this.store.select(fromPaymentCredit.getPaymentCreditScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));

        this.stateFormCCData$ = this.store.select(fromPaymentCredit.getPaymentCreditFormCCState).pipe(skipWhile(data => data === undefined || data === null));
        this.stateProcessedFormCCData$ = this.store.select(fromPaymentCredit.getProcessedPaymentCreditFormCCState).pipe(skipWhile(data => data === undefined || data === null));

        this.stateFormCGData$ = this.store.select(fromPaymentCredit.getPaymentCreditFormCGState).pipe(skipWhile(data => data === undefined || data === null));
        this.stateProcessedFormCGData$ = this.store.select(fromPaymentCredit.getProcessedPaymentCreditFormCGState).pipe(skipWhile(data => data === undefined || data === null));

        this.stateFormPPData$ = this.store.select(fromPaymentCredit.getPaymentCreditFormPPState).pipe(skipWhile(data => data === undefined || data === null));
        this.stateProcessedFormPPData$ = this.store.select(fromPaymentCredit.getProcessedPaymentCreditFormPPState).pipe(skipWhile(data => data === undefined || data === null));

        this.stateFormESData$ = this.store.select(fromPaymentCredit.getPaymentCreditFormESState).pipe(skipWhile(data => data === undefined || data === null));
        this.stateProcessedFormESData$ = this.store.select(fromPaymentCredit.getProcessedPaymentCreditFormESState).pipe(skipWhile(data => data === undefined || data === null));

        // this.stateFormCIData$ = this.store.select(fromPaymentCredit.getPaymentCreditFormCIState).skipWhile(data => data === null && data === undefined);
        // this.stateProcessedFormCIData$ = this.store.select(fromPaymentCredit.getProcessedPaymentCreditFormCIState).skipWhile(data => data === null && data === undefined);
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            setTimeout(() => {
                this.ams.showLoader('Loading...');
                this.ref.markForCheck();
            })
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error === 'Success') { // ignore the initial load
                    this.displaySuccess();
                } else if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new PaymentCreditAction.PaymentCreditScreenErrorReset());
        });
    }

    displaySuccess(): void {
        this.ams.showAlert("Success!", 'Successfully Updated!');
    }

    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }

    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {

        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });

        this.stateFormCCDataSubscription = this.stateFormCCData$
            .subscribe(data => {
                this.FormccToPayAsCreditDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });
        this.stateProcessedFormCCDataSubscription = this.stateProcessedFormCCData$
            .subscribe(data => {
                this.FormCCPaidDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });

        this.stateFormCGDataSubscription = this.stateFormCGData$
            .subscribe(data => {
                this.FormCGToPayAsCreditDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });
        this.stateProcessedFormCGDataSubscription = this.stateProcessedFormCGData$
            .subscribe(data => {
                this.FormCGPaidDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });

        this.stateFormPPDataSubscription = this.stateFormPPData$
            .subscribe(data => {
                this.FormPPToPayAsCreditDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });
        this.stateProcessedFormPPDataSubscription = this.stateProcessedFormPPData$
            .subscribe(data => {
                this.FormPPPaidDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });

        this.stateFormESDataSubscription = this.stateFormESData$
            .subscribe(data => {
                this.FormESToPayAsCreditDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });
        this.stateProcessedFormESDataSubscription = this.stateProcessedFormESData$
            .subscribe(data => {
                this.FormESPaidDetails = JSON.parse(JSON.stringify(data));
                this.ref.markForCheck();
            });

        // this.stateFormCIDataSubscription = this.stateFormCIData$
        //     .subscribe(data => {
        //         this.FormCIToPayAsCreditDetails = JSON.parse(JSON.stringify(data));
        //         this.ref.markForCheck();
        //     });
        // this.stateProcessedFormCIDataSubscription = this.stateProcessedFormCIData$
        //     .subscribe(data => {
        //         this.FormCIPaidDetails = JSON.parse(JSON.stringify(data));
        //         this.ref.markForCheck();
        //     });
    }

    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();

        this.stateFormCCDataSubscription.unsubscribe();
        this.stateProcessedFormCCDataSubscription.unsubscribe();

        this.stateFormCGDataSubscription.unsubscribe();
        this.stateProcessedFormCGDataSubscription.unsubscribe();

        this.stateFormPPDataSubscription.unsubscribe();
        this.stateProcessedFormPPDataSubscription.unsubscribe();

        this.stateFormESDataSubscription.unsubscribe();
        this.stateProcessedFormESDataSubscription.unsubscribe();

        // this.stateFormCIDataSubscription.unsubscribe();
        // this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditInitState());
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }

}